export const LOCAL_STORAGE_KEY_PREFERRED_THEME = "preferredTheme";
